module.exports = __webpack_public_path__ + "media/images/systemuser-2bbe4cef2f1e451d638ab84af251ee82.png";